import type { EmployeeExposure, ExposureCategoryExtended } from '../../types/server/generics/exposure'
import type { Role } from '../../types/server/generics/role'
import { CircularProgress, Text, ScaleFade, HStack, Tr, Td } from '@chakra-ui/react'
import { useUserBlueprints } from '../../services/blueprint.service'
import { useRoleStore } from '../../components/Topbar'
import { Link, useParams } from 'react-router-dom'

export function getAllSubRoles(roleId: string, roles: Role[], visited = new Set<string>()): Role[] {
    if (visited.has(roleId)) return []
    visited.add(roleId)
    const directSubs = roles.filter((r) => r.parentIds?.includes(roleId))
    const allSubs = [...directSubs]
    for (const sub of directSubs) {
        allSubs.push(...getAllSubRoles(sub.id, roles, visited))
    }
    return Array.from(new Set(allSubs))
}

const Employee = ({
	id: employeeId,
	index,
	data,
	...baseEmployee
}: EmployeeExposure & { index: number; data: ExposureCategoryExtended | null }) => {
	const { data: employeeBlueprints } = useUserBlueprints(employeeId)
	const { id, companyId } = useParams()

	const role = useRoleStore((state) => state.role)
	const companyRoles = data?.company?.roles || []
	const allSubRoles = role ? getAllSubRoles(role.id, companyRoles) : []

	const employee = {
		...baseEmployee,
		...(data?.company?.employees?.filter((x) => x._id === employeeId)?.[0] || {}),
	}

	console.log({ company: data?.company, employeeBlueprints, companyId })

	// For each tasklist -> blueprint
	const roleToTaskMap = employeeBlueprints.reduce((acc, blueprint) => {
		// If there is a companyId, add the tasklist (blueprint) id to the roleId
		if (companyId) {
			acc[(blueprint.role as Role)._id] = blueprint._id
		} else {			
			// Else, check if the roleId is in the parentIds of the role that connected to the tasklist (blueprint)
			const taskRole = data?.company?.roles.find((mapRole) => mapRole._id === (blueprint.role as Role)._id)
			const isRoleInSubRoles = allSubRoles.some((subRole) => subRole._id === taskRole?._id)

			const parentIds = taskRole?.parentIds || []

			if (employee.name === 'עובד לעריכה 1') {
				console.log({
					roleId: role?.id,
					parentIds,
					allRoles: data?.company?.roles,
					test: isRoleInSubRoles,
				})
			}

			if (
				role && // Check if role is defined
				// isHaveRoleIdInParents(role.id, parentIds, data?.company?.roles || []) && // Check if the defined role is in the parentIds of the blueprint role
				isRoleInSubRoles &&
				blueprint.tasks?.some((task) => task.riskId === id) // Check if the tasklist (blueprint) has tasks that belong to the category (params.id)
			) {
				console.log('ROLE IS IN PARENT IDS', role.id, parentIds, blueprint.role)
				acc[(blueprint.role as Role)._id] = blueprint._id // Add the tasklist (blueprint) id to the roleId
			}
		}

		return acc
	}, {} as Record<string, string>)

	const exposure = employee.sum > 0 ? (employee.exposure || 0) * 100 : 100
	if (employee.name === 'עובד לעריכה 1') {
		console.log('employee', { sum: employee.sum, exposure: employee.exposure })
	}

	const roles = data?.company?.roles?.filter((role) => {
		return !(!roleToTaskMap || !roleToTaskMap[role._id] || !employee._id)
	})

	if (employee.name === 'עובד לעריכה 1') console.log('roles', roleToTaskMap, roles)

	// if (!employee.isActive) return null
	if (!employee.sum) return null
	if(!roles?.length) return null

	return (
		<Tr
			rounded={'10px'}
			border={'none'}
			key={id}
			pos={'relative'}
		>
			<Td
				bg={index % 2 === 0 ? 'white' : '#F5F8FA'}
				border={'none'}
				roundedRight='10px'
				textAlign='start'
			>
				<Text
					flex={1}
					whiteSpace='nowrap'
					px={2}
					fontSize={15}
					fontWeight='bold'
					color='#3FB2D2'
				>
					{roles && roles.length > 0 ? (
						<span>
							{roles.map((role, idx) => {
								const isLast = idx === roles.length - 1

								return (
									<>
										<Link
											className={
												!roleToTaskMap || !roleToTaskMap[role._id] || !employee._id
													? 'disabled'
													: ''
											}
											to={`/tasks/${roleToTaskMap?.[role._id] ? role._id : ''}?user_id=${
												employee.id
											}`}
											key={role._id}
										>
											{employee.name} ({role.name})
										</Link>
										<span key={role._id}>{isLast ? '' : ', '}</span>
									</>
								)
							})}
						</span>
					) : (
						employee.name
					)}
				</Text>
			</Td>

			<Td
				display='flex'
				alignItems='flex-start'
				justifyContent='flex-start'
				textAlign='center'
				border={'none'}
				bg={index % 2 === 0 ? 'white' : '#F5F8FA'}
				roundedLeft={'10px'}
			>
				<ScaleFade
					in
					initialScale={0}
				>
					<HStack spacing={1}>
						<Text
							textAlign={'end'}
							width={'50px'}
						>
							{exposure.toFixed(0)}%
						</Text>
						<CircularProgress
							value={exposure}
							size='40px'
							thickness='10px'
							color={
								exposure < 25
									? 'red.500'
									: exposure < 50
									? 'yellow.300'
									: exposure < 85
									? '#F6A860'
									: '#3FB2D2'
							}
						/>
					</HStack>
				</ScaleFade>
			</Td>

			<Td
				bg={index % 2 === 0 ? 'white' : '#F5F8FA'}
				border={'none'}
				textAlign='start'
			>
				<Text
					px={5}
					fontSize={15}
					textAlign='start'
					gap='5'
					alignItems={'flex-start'}
					justifyContent='center'
					whiteSpace='nowrap'
					width={'100%'}
				>
					{roles && roles.length > 0 ? (
						<span>
							{roles.map((role, idx) => (
								<>
									{role.name}
									<span key={role._id}>{idx < roles.length - 1 ? ', ' : ''}</span>
								</>
							))}
						</span>
					) : (
						'--'
					)}
				</Text>
			</Td>
		</Tr>
	)
}

export default Employee
